<template>
  <div class="container edit-user-template">
    <div class="page-header color-1-100">
      <h1>
        Default email templates
      </h1>
    </div>
    <div class="admin-gm-breadcrumbs" tabindex="-1">
      <router-link class="companies active" :to="{name: 'default-email-templates'}">Email templates</router-link>
    </div>
    <div class="industry-emails">
      <div class="industry-emails-container">
        <div class="industry-emails-menu">
          <div v-if="emailTemplates">
            <div class="section-head">
              Email templates
            </div>
            <div class="section-body">
              <template>
                <router-link class="section-item"
                             v-bind:class="{ 'active': template === item.value }"
                             v-bind:key="item.value"
                             v-for="item in emailTemplates"
                             :to="{name: 'default-email-templates', query: {template: item.value}}">{{ item.label }}</router-link>
              </template>
            </div>
          </div>
        </div>
        <div class="industry-emails-content">
          <div class="content-section content-section__bordered border-1-20 no-margin-top" ref="templateDetails">
            <article class="personal-info">
              <h3 class="content-section-title color-1-100 background-1-100-before">
                <template v-if="canEditTemplate === false">{{ templateLabel }} email</template>
                <template v-else>Edit "{{ templateLabel }}" email</template>
              </h3>
              <div class="content-section-text">
                <p>{{ emailTemplate.description }}</p>
                <p class="variables-list">
                  It supports the following variables:
                </p>
                <dl>
                  <template v-for="(variable, index) in emailTemplate.variables">
                    <dt>
                      <code>[{{ variable }}]</code>
                    </dt>
                    <dt class="code-separator" v-if="index !== Object.keys(emailTemplate.variables).length - 1"></dt>
                  </template>
                </dl>
              </div>
              <button v-on:click.prevent="openEditTemplate()" class="edit-details border-1-40 color-2-100" v-if="canEditTemplate === false">Edit</button>
            </article>
          </div>
          <div class="content-section content-section__bordered border-1-20"
               v-bind:class="{ 'content-section__no_padding': canEditTemplate === false }" ref="templatePreview">
            <div v-show="canEditTemplate === false">
              <div id="emailBody"></div>
            </div>
            <article class="personal-info" v-if="canEditTemplate === true">
              <div class="form-group">
                <div class="form-element">
                  <label for="template-subject" class="form-label color-2-63">Subject</label>
                  <input type="text" class="form-control form-control__input background-1-10-disabled  border-1-10-disabled"
                         :class="[{ 'has-error': errors.has('Subject') } ]"
                         :disabled="canEditTemplate === false"
                         v-model="emailTemplate.email.subject"
                         data-lpignore="true"
                         id="template-subject"
                         v-validate="'required'"
                         name="Subject">
                  <span class="form-field-error" v-if="this.errors.has('Subject')">
                    {{ this.errors.first('Subject') }}
                  </span>
                </div>
              </div>
              <div class="form-group">
                <div class="form-element">
                  <label for="template-title" class="form-label color-2-63">Title</label>
                  <input type="text" class="form-control form-control__input background-1-10-disabled  border-1-10-disabled"
                         :class="[{ 'has-error': errors.has('Title') } ]"
                         :disabled="canEditTemplate === false"
                         v-model="emailTemplate.email.title"
                         data-lpignore="true"
                         id="template-title"
                         v-validate="'required'"
                         name="Title">
                  <span class="form-field-error" v-if="this.errors.has('Title')">
                    {{ this.errors.first('Title') }}
                  </span>
                </div>
              </div>
              <div class="form-group">
                <div class="form-element">
                  <label for="template-body" class="form-label color-2-63">Email body</label>
                  <vue-editor
                    id="template-body"
                    :editorToolbar="editorToolbar"
                    name="body"
                    class="article-editor"
                    v-model="emailTemplate.email.body"
                  />
                </div>
              </div>
              <div class="clearfix"></div>
              <div class="update-data update-data__details" v-if="canEditTemplate">
                <button v-on:click.prevent="closeEditTemplate()" class="cancel-edit background-2-7 color-2-100 cancel-edit-details">Discard changes</button>
                <button v-on:click.prevent="updateEmailTemplate()" class="save-edit background-1-100 color-2-100 save-edit-details">Save changes</button>
              </div>
            </article>
          </div>
          <div class="content-section content-section__bordered border-1-20 no-margin-top" ref="testTemplate">
            <article class="personal-info">
              <h3 class="content-section-title color-1-100 background-1-100-before">
                Send test email
              </h3>
              <div class="form-group">
                <div class="form-element">
                  <label for="email-address" class="form-label color-2-63">Email address</label>
                  <input type="text" class="form-control form-control__input background-1-10-disabled  border-1-10-disabled"
                         :class="[{ 'has-error': errors.has('Email address') } ]"
                         v-model="testEmail.email"
                         data-lpignore="true"
                         id="email-address"
                         v-validate="'required'"
                         name="Email address">
                  <span class="form-field-error" v-if="this.errors.has('Email address')">
                    {{ this.errors.first('Email address') }}
                  </span>
                </div>
              </div>
              <div class="clearfix"></div>
              <div class="update-data update-data__details">
                <button v-on:click.prevent="sendTestEmail()" class="save-edit background-1-100 color-2-100 save-edit-details">Send</button>
              </div>
            </article>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import api from '@/api'
  import { mapActions, mapGetters } from 'vuex'

  export default {
    name: 'edit-default-emails',
    data () {
      return {
        template: null,
        infMsgTitle: '',
        infMsgDescription: '',
        infMsgClass: '',
        confOpened: null,
        confirmation: {
          action: '',
          isShown: false,
          articleId: null,
          i: null,
          style: {
            top: '100px'
          }
        },
        customizedEmailTemplates: null,
        emailTemplates: null,
        emailTemplate: {
          id: null,
          description: '',
          variables: null,
          email: {
            template: '',
            subject: '',
            title: '',
            body: '',
            isDefault: 1
          }
        },
        testEmail: {
          email: 'tcc@eromagency.com'
        },
        canEditTemplate: false,
        disableAPI: false,
        editorToolbar: [
          [{'header': [2, 3, 4, 5, 6, false]}],
          ['bold', 'italic', 'underline', 'strike', {'color': []}, {'background': []}],
          [{'list': 'ordered'}, {'list': 'bullet'}],
          [{'indent': '-1'}, {'indent': '+1'}],
          ['blockquote', 'code-block', 'image', 'link'],
          [{'font': []}],
          [{'align': []}],
          ['clean']
        ],
        previewEmail: null
      }
    },
    computed: {
      ...mapGetters([
        'getConfData'
      ]),
      templateLabel () {
        if (!this.emailTemplates) {
          return ''
        }
        let template = this.emailTemplates.find((item) => item.value === this.template)
        return template ? template.label : ''
      }
    },
    methods: {
      ...mapActions([
        'clearConfAction',
        'setInformationMsg',
        'initConfAction',
        'authLogout'
      ]),
      getEmailTemplates () {
        this.$http.get(`${api.URLS.emailTemplate}/list`, api.headersAuthSettings).then((res) => {
          this.emailTemplates = res.body
          if (!this.template) {
            let firstTemplate = res.body[0]
            this.$router.push({ query: {template: firstTemplate.value} })
          }
        }).catch((err) => {
          if (err.status === 404) {
            let props = this.$router.resolve({
              name: 'error'
            })
            this.$router.push(props.href)
          }
          if (err.status === 401) {
            this.authLogout()
          }
        })
      },
      getEmailTemplate () {
        if (!this.template) {
          return
        }
        this.$http.get(`${api.URLS.emailTemplate}/${this.template}`, api.headersAuthSettings).then((res) => {
          this.emailTemplate.id = res.body.id || null
          this.emailTemplate.variables = res.body.variables || null
          this.emailTemplate.description = res.body.description || ''
          if (this.emailTemplate.email) {
            this.emailTemplate.email.template = res.body.email ? res.body.email.template : ''
            this.emailTemplate.email.subject = res.body.email ? res.body.email.subject : ''
            this.emailTemplate.email.title = res.body.email ? res.body.email.title : ''
            this.emailTemplate.email.body = res.body.email ? res.body.email.body : ''
            this.emailTemplate.email.isDefault = res.body.email ? res.body.email.isDefault : 1
          }
          this.previewEmail = res.body.emailHtml ? res.body.emailHtml : ''
          this.buildEmailFrame(this.previewEmail)
        }).catch((err) => {
          if (err.status === 404) {
            let props = this.$router.resolve({
              name: 'error'
            })
            this.$router.push(props.href)
          }
          if (err.status === 401) {
            this.authLogout()
          }
        })
      },
      openEditTemplate: function () {
        this.canEditTemplate = true
      },
      closeEditTemplate: function () {
        this.canEditTemplate = false
      },
      updateEmailTemplate () {
        if (this.disableAPI) return
        this.$validator.validateAll()
        if (this.errors.items.length) return
        let emailData = {
          template: this.template,
          subject: this.emailTemplate.email.subject,
          title: this.emailTemplate.email.title,
          body: this.emailTemplate.email.body,
          isDefault: 1
        }
        if (this.emailTemplate.id) {
          emailData['id'] = this.emailTemplate.id
        }
        this.disableAPI = true
        this.$http.post(`${api.URLS.emailTemplate}`, emailData, api.headersAuthSettings)
          .then((res) => {
            this.disableAPI = false
            this.infMsgTitle = this.templateLabel + ' email was successfully updated.'
            this.infMsgDescription = 'Please note all edits are being logged.'
            this.infMsgClass = 'success'
            this.setInformationMsg({
              isShown: true,
              title: this.infMsgTitle,
              text: this.infMsgDescription,
              className: this.infMsgClass
            })
            this.getEmailTemplate()
            this.canEditTemplate = !this.canEditTemplate
          })
          .catch((err) => {
            this.disableAPI = false
            this.infMsgTitle = 'Error. We were not able to update this email because '
            for (let error in err.body.error.exception) {
              this.infMsgTitle += err.body.error.exception[error].message + ' '
            }
            this.infMsgDescription = 'If you need assistance, please send an email to tcc@eromagency.com in the following format: “I was on this page (insert the URL of the page where you got this error), did this action, was expecting to get this result, but got this error instead. It happened at this time on this date, while using this operating system and this browser (please insert browser version as well - usually it can be found in browser menu → Help → About), being logged in with this user. On a scale from 1 to 10 (where 1 means there is no rush and 10 means I need it yesterday), I need a solution for this with this priority”. Thank you.'
            this.infMsgClass = 'error'
            this.setInformationMsg({
              isShown: true,
              title: this.infMsgTitle,
              text: this.infMsgDescription,
              className: this.infMsgClass
            })
            this.getEmailTemplate()
          })
      },
      sendTestEmail () {
        if (this.disableAPI) return
        this.$validator.validateAll()
        if (this.errors.items.length) return
        let emailData = {
          subject: this.templateLabel + ' test email',
          body: this.previewEmail,
          email: this.testEmail.email
        }
        this.disableAPI = true
        this.$http.post(`${api.URLS.testEmail}`, emailData, api.headersAuthSettings)
          .then((res) => {
            this.disableAPI = false
            this.infMsgTitle = this.templateLabel + ' email test successfully sent.'
            this.infMsgDescription = 'Please check your inbox.'
            this.infMsgClass = 'success'
            this.setInformationMsg({
              isShown: true,
              title: this.infMsgTitle,
              text: this.infMsgDescription,
              className: this.infMsgClass
            })
          })
          .catch((err) => {
            this.disableAPI = false
            this.infMsgTitle = 'Error. We were not able to send test email because '
            for (let error in err.body.error.exception) {
              this.infMsgTitle += err.body.error.exception[error].message + ' '
            }
            this.infMsgDescription = 'If you need assistance, please send an email to tcc@eromagency.com in the following format: “I was on this page (insert the URL of the page where you got this error), did this action, was expecting to get this result, but got this error instead. It happened at this time on this date, while using this operating system and this browser (please insert browser version as well - usually it can be found in browser menu → Help → About), being logged in with this user. On a scale from 1 to 10 (where 1 means there is no rush and 10 means I need it yesterday), I need a solution for this with this priority”. Thank you.'
            this.infMsgClass = 'error'
            this.setInformationMsg({
              isShown: true,
              title: this.infMsgTitle,
              text: this.infMsgDescription,
              className: this.infMsgClass
            })
          })
      },
      buildEmailFrame (html) {
        let emailBody = document.getElementById('emailBody')
        let iframe = document.createElement('iframe')
        emailBody.innerHTML = ''
        emailBody.appendChild(iframe)
        iframe.onload = function resizeIframe () {
          this.style.height = this.contentWindow.document.documentElement.scrollHeight + 'px'
        }
        iframe.style.width = '100%'
        iframe.contentWindow.document.open()
        iframe.contentWindow.document.write(html)
        iframe.contentWindow.document.close()
      }
    },
    components: {},
    watch: {
      'getConfData.actionConfirmed' (value) {
        if (value) {
          if (this.confOpened === 'delete') {
            this.deleteIndustryConfirmed()
          }
          this.clearConfAction()
        }
      },
      '$route.query.template' () {
        this.template = this.$route.query.template
        this.canEditTemplate = false
        this.getEmailTemplates()
        this.getEmailTemplate()
      }
    },
    beforeMount () {},
    created () {
      this.template = this.$route.query.template
      document.title = 'Default email templates | Clear Assured'
      if (window.ga) {
        window.ga('set', 'contentGroup1', 'ADMINISTRATION_AREA')
        window.ga('send', 'pageview', {
          'page': location.pathname,
          'location': location.href,
          'title': document.title
        })
      }
    },
    mounted () {
      this.getEmailTemplates()
      this.getEmailTemplate()
    },
    destroyed () {}
  }
</script>

<style src='@/assets/scss/components/profile.scss' lang='scss' />



// WEBPACK FOOTER //
// EditDefaultEmails.vue?788376c6